import _ from 'lodash'
import PathInterface from '../interfaces/PathInterface'

export function fixPath(path: string): string {
  return '/' + _.trim(path.replace(/([^:]\/)\/+/g, '$1'), '/')
}

export function parsePath(path: string): PathInterface {
  let pathParts = path.split('#')
  const hashString = pathParts[1]
  pathParts = pathParts[0].split('?')
  const searchString = pathParts[1]
  return {
    base: pathParts[0],
    searchParams: searchString?.split('&') || [],
    hash: hashString || '',
  }
}
